import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';

import { throwError } from 'rxjs';



import { USER_EDIT_RETURN_TYPE, USER_EDIT_CTO_REQUESTID, USER_EDIT_CTO_TRACKID } from '../../user-edit.config';
import { ANALYTICS_CONSTANTS } from 'config';

import { HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
declare var ENV_PORTAL;
@Injectable()
export class UserEditService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService, private adobeAnalyticsService: AdobeAnalyticsService) { }

  saveUserInfo(servicename, body) {
    return this.httpClientService.authorizedPatch(servicename, body)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      })
      ,catchError( this.handleError ));
  }

  // Page Load
  createPageLoadProperties(url: string, title: string) {
    const dataLayer = {};
    const removeProductId = url.substring(0, url.lastIndexOf('/'));
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = ANALYTICS_CONSTANTS.ENVIRONMENT_URL + removeProductId;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_USER_EDIT;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_MANAGE;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  handleError = (error) => {
    return throwError(error);
  }
}
